import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { alignItems, display, maxWidth, space, width } from 'styled-system';

import { boxSizing } from 'common/theme/system-utilities';

const UnstyledListItem = styled.li<any>`
  ${display};
  ${width};
  ${space};
  ${alignItems};
  ${maxWidth};
  ${boxSizing};
`;

export const ListItem = (props: ComponentProps<typeof UnstyledListItem>) => (
  <UnstyledListItem
    display="flex"
    alignItems="flex-start"
    maxWidth="100%"
    boxSizing="border-box"
    {...props}
  />
);
